import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, shareReplay } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Metadata } from './metadata.models';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

/**
 * Shared metadata API service.
 * Fetches and caches grades and tier1/tier2 subjects from the backend.
 * Used by both lesson plan and assignment features.
 */
@Injectable({
  providedIn: 'root',
})
export class MetadataApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/lesson-plans`;

  /** Cached metadata observable — fetched once and shared across all consumers */
  private metadata$: Observable<Metadata> | null = null;

  /**
   * Get metadata (grades, tier1/tier2 subjects).
   * Cached to avoid refetching on every component mount.
   */
  getMetadata(): Observable<Metadata> {
    if (!this.metadata$) {
      this.metadata$ = this.http
        .get<ApiResponse<Metadata>>(`${this.apiUrl}/metadata`)
        .pipe(
          map((res) => res.data),
          shareReplay(1),
        );
    }
    return this.metadata$;
  }
}
